import { Link, useNavigate } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import Toaster from "../../components/toaster"
import { useEffect, useState } from "react"

const ViewProfile = () => {
    const [profileDetails, setProfileDetails] = useState()
    const [toaster, setToaster] = useState({ visiblity: "hide" });
const navigate = useNavigate();
    const getMyProfile = async () => {
        try {
            const response = await services.Vendor.GET_VENDOR();
            if (response.data) {
                setProfileDetails(response.data);
            }
        } catch (error) {
            console.log(error)
        }
    }
    const HandleOnChangeValue = (e, key, type) => {
        let obj = { ...profileDetails }
        if (type) {
            obj[key] = e;
        } else {
            obj.VendorDetail[key] = e;
        }

        setProfileDetails({ ...obj })
    }
    useEffect(() => {
        getMyProfile();
    }, [])
    const onSubmitHandler = async () => {
        try {
            let data = {
                userData: {
                    firstName: profileDetails.firstName,
                    lastName: profileDetails.lastName,
                    phoneNumber: profileDetails.phoneNumber,
                    email: profileDetails.email
                },
                vendorData: {
                    aadharLinkedPhoneNumber: profileDetails.VendorDetail.aadharLinkedPhoneNumber,
                    aadharNumber: profileDetails.VendorDetail.aadharNumber,
                }
            }
            const response = await services.Vendor.UPDATE_VENDOR(data)
            setToaster({
                type: "success",
                title: "Login",
                text: 'Profile Updated successfully',
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
                navigate('/')
            }, 3000)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error",
                text: error.response.data.message,
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 60000)
        }
    }
    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />
            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div >
                                                <h4 class="user-profile-card-title d-flex justify-content-between">Profile Info <span class={`badge text-capitalize badge-${profileDetails?.VendorDetail?.approvalStatus == 'approved' ? 'success' : 'danger'}`}>{profileDetails?.VendorDetail?.approvalStatus}</span></h4>

                                            </div>
                                            <div class="user-profile-form">

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>First Name</label>
                                                            <input disabled={true} onChange={(e) => HandleOnChangeValue(e.target.value, 'firstName', 'user')} type="text" class="form-control" value={profileDetails?.firstName}
                                                                placeholder="First Name" />
                                                               
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Last Name</label>
                                                            <input disabled={true} onChange={(e) => HandleOnChangeValue(e.target.value, 'lastName', 'user')} type="text" class="form-control" value={profileDetails?.lastName}
                                                                placeholder="Last Name" />
                                                                
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Phone Number</label>
                                                            <input disabled={true} onChange={(e) => HandleOnChangeValue(e.target.value, 'phoneNumber', 'user')} type="number" class="form-control"
                                                                value={profileDetails?.phoneNumber} placeholder="Phone number" />
                                                                
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Aadhaar Number</label>
                                                            <input disabled={true}  onChange={(e) => HandleOnChangeValue(e.target.value, 'aadharNumber')} type="number" class="form-control"
                                                                value={profileDetails?.VendorDetail?.aadharNumber} placeholder="Aadhar Number" />
                                                               
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Aadhaar-linked Mobile</label>
                                                            <input disabled={true} onChange={(e) => HandleOnChangeValue(e.target.value, 'aadharLinkedPhoneNumber')} type="number" class="form-control"
                                                                value={profileDetails?.VendorDetail?.aadharLinkedPhoneNumber} placeholder="Aadhar Linked Number " />
                                                                
                                                        </div>
                                                    </div>
                                              
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Email</label>
                                                            <input disabled={true} type="email" class="form-control"
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'email','user')} value={profileDetails?.email} placeholder="Email" />
                                                        </div>
                                                    </div>
                                            

                                                </div>
                                                <Link to={'/myprofile'} class="theme-btn my-3"><span
                                                    class="far fa-user"></span> Edit Profile</Link>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default ViewProfile